import { createSelector } from "@reduxjs/toolkit";
import selectAnnotationReducer from "./annotationReducerSelector";
import { RootState } from "../../app";

type Props = {
  entityId: string;
  groupBlockIndex: number;
};

const selectEntityId = (_: RootState, props: Props) => props.entityId;
const selectGroupBlockIndex = (_: RootState, props: Props) =>
  props.groupBlockIndex;

const rowHasAdjacentAnnotationsForEntitySelector = createSelector(
  [selectAnnotationReducer, selectEntityId, selectGroupBlockIndex],
  (annotations, entityId, groupBlockIndex): [boolean, boolean] => {
    if (!annotations?.length) {
      return [false, false];
    }

    return [
      annotations.filter(
        (annotation) =>
          annotation?.entity?.id === entityId &&
          annotation?.index === groupBlockIndex - 1,
      ).length > 0,
      annotations.filter(
        (annotation) =>
          annotation?.entity?.id === entityId &&
          annotation?.index === groupBlockIndex + 1,
      ).length > 0,
    ];
  },
);

export default rowHasAdjacentAnnotationsForEntitySelector;
